import React from 'react'
import { UnauthorizedError } from './components/UnauthorizedError/unauthorized-error'
import { PageNotFoundError } from './components/PageNotFoundError/page-not-found-error'
import { UnauthorizedUser } from './components/UnauthorizedUser/unauthorized-user'
import { TableauRegistrationError } from './components/TableauRegistrationError/tableau-registration-error'
import { errorCodes } from '../../constants/error-codes'

function ErrorState({ errorCode }) {
  const getErrorState = () => {
    switch (errorCode) {
      case errorCodes.http.ERROR_401:
        return <UnauthorizedError />
      case errorCodes.http.ERROR_404:
        return <PageNotFoundError />
      case errorCodes.http.ERROR_UNAUTHORIZED:
        return <UnauthorizedUser />
      case errorCodes.http.TABLEAU_ERROR_404:
        return <TableauRegistrationError />
      default:
        return null
    }
  }

  return getErrorState()
}

export default ErrorState
